import React, { FC } from 'react'

const MasterCardIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.75508 18.248H15.2448V6.58588H8.75508V18.248Z" fill="#9699B6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16729 12.4169C9.16729 10.0511 10.2752 7.94408 12.0001 6.58586C10.7383 5.59252 9.14664 5 7.41643 5C3.32037 5 0 8.32086 0 12.4169C0 16.513 3.32037 19.8339 7.41643 19.8339C9.14664 19.8339 10.7383 19.2413 12.0001 18.248C10.2752 16.8898 9.16729 14.7828 9.16729 12.4169Z"
      fill="#747796"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12.4164C24 16.513 20.6796 19.8334 16.5836 19.8334C14.8534 19.8334 13.2614 19.2413 12.0001 18.248C13.725 16.8903 14.8328 14.7824 14.8328 12.4164C14.8328 10.0506 13.725 7.94408 12.0001 6.58586C13.2614 5.59302 14.8534 5 16.5836 5C20.6796 5 24 8.32037 24 12.4164Z"
      fill="#ADB0CC"
    />
  </svg>
)

export default MasterCardIcon
